import React from 'react';
import classes from "./styles.module.scss";
import ArrowDown from "../../assets/images/down.png";
import PropTypes from 'prop-types';

const CustomSelect = ({ label, options, second_class, star, placeholder, onChange, value, optionLabel, optionValue, name, disabled }) => {
    
    return (
        <div className={`${classes.custom_select_container} ${second_class}`}>
            {label && <label>{label} <span>{star}</span></label>}
            <div className={classes.select_wrapper}>
                <select disabled={disabled} name={name} required={star} value={value} onChange={onChange} className={classes.custom_select}>
                    {placeholder && (
                        <option  value="" >
                            {placeholder}
                        </option>
                    )}
                    {Array.isArray(options) &&  options?.map((option,index) => (
                        <option key={index} value={option[optionValue]} className={classes.options}>
                            <p className={classes.padding}>
                                {option[optionLabel]}
                            </p>
                        </option>
                    ))}
                </select>
                <img className={classes.down} src={ArrowDown} alt='Dropdown Arrow' />
            </div>
        </div>
    );
};

CustomSelect.propTypes = {
    disabled : PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ).isRequired,
    second_class: PropTypes.string,
    star: PropTypes.node,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value:PropTypes.any,
    optionLabel : PropTypes.any,
    optionValue : PropTypes.any,
    name: PropTypes.string
};

export default CustomSelect;